import React from 'react';

import { Button, Typography } from 'wtb-components';
import { useLocaleContext, useTransactionContext } from 'context';
import { redirectToMerchant } from './redirectToMerchant';
import styles from './MerchantRedirect.module.css';

const MerchantRedirect = () => {

  const { merchant: { name, redirect } } = useTransactionContext();
  const { translate } = useLocaleContext();
  const handleRedirect = () => { redirectToMerchant(redirect?.successUrl); };

  return (
    <div className={styles.root}>
      <Typography variant="body1" fontWeight="bold">{translate('merchantRedirect.title')}</Typography>
      <Typography variant="body2" color="textSecondary" align="center">{translate('merchantRedirect.subtitle', { merchant: name })}</Typography>
      <Button className={styles.button} onClick={handleRedirect}>
        {translate('merchantRedirect.button', { merchant: name })}
      </Button>
    </div>
  );
};

export default MerchantRedirect;
